module.exports = __webpack_public_path__ + "static/img/94afb7fc59abc1b930271c8ddbd3e469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usb_box.png
// module id = owTZ
// module chunks = 1